// extracted by mini-css-extract-plugin
module.exports = {"banner":"_3JBKp","title":"_3SLeF","button":"_1lHpb","bannerTwo":"_32umF","right":"ycvyf"};